import React from 'react';
import { Info, ChevronDown, ChevronUp } from 'lucide-react';

const EscrowFeeBreakdown = ({ feeData }) => {
  const [expanded, setExpanded] = React.useState(false);
  
  const formatPrice = (price) => {
    if (!price && price !== 0) return '₦0';
    const num = typeof price === 'string' ? parseFloat(price) : price;
    return `₦${num.toLocaleString('en-NG', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
  };
  
  return (
    <div className="bg-white rounded-xl shadow-sm p-5 border">
      <div 
        className="flex items-center justify-between cursor-pointer"
        onClick={() => setExpanded(!expanded)}
      >
       
        {expanded ? (
          <ChevronUp className="w-5 h-5 text-gray-500" />
        ) : (
          <ChevronDown className="w-5 h-5 text-gray-500" />
        )}
      </div>
      
      {expanded && (
        <div className="mt-4 pt-4 border-t border-gray-100">
          <div className="space-y-3">
            <div className="flex justify-between">
              <span className="text-gray-600">Product Amount:</span>
              <span className="font-medium">{formatPrice(feeData.product_amount)}</span>
            </div>
            
            
            
            <div className="pt-2 border-t border-gray-200">
              <div className="flex justify-between">
                <span className="text-gray-600">Total Fees:</span>
                <span className="text-gray-600">{formatPrice(feeData.total_fees)}</span>
              </div>
            
            </div>
            
            <div className="pt-3 border-t border-gray-200">
              <div className="flex justify-between items-center">
                <span className="font-semibold text-gray-900">You Pay:</span>
                <span className="text-xl font-bold text-gray-900">
                  {formatPrice(feeData.buyer_pays_total)}
                </span>
              </div>
              
            
            </div>
          </div>
        </div>
      )}
      
      {!expanded && (
        <div className="mt-3 p-3 bg-gray-50 rounded-lg">
          <div className="flex justify-between items-center">
            <div>
              <p className="text-sm font-medium text-gray-900">
                Total: {formatPrice(feeData.buyer_pays_total)}
              </p>
              <p className="text-xs text-gray-600">
                Includes {formatPrice(feeData.buyer_fee_share)} in fees
              </p>
            </div>
            
          </div>
        </div>
      )}
    </div>
  );
};

export default EscrowFeeBreakdown;